import { Autocomplete, Button, Card, CardContent, CardHeader, TextField } from '@mui/material';
import axios from 'axios';
import { useState, useEffect } from 'react';
import constants from '../constants';

const SettingsCard = ({
	company,
	companies,
	expertId,
	expertStats,
	handleChangeMyCompany,
	handleChangeMyExpert,
	handleCopyNoWixEmails,
	handleCopyNewbornEmails,
	activeNewborns,
	setShowKidsDOBModal,
	memberDating,
}: {
	company: string;
	companies: any[];
	expertId: string;
	expertStats: any;
	handleChangeMyCompany: (company: string) => void;
	handleChangeMyExpert: (expertId: string) => void;
	handleCopyNoWixEmails: () => void;
	handleCopyNewbornEmails: () => void;
	activeNewborns: any;
	setShowKidsDOBModal: (show: boolean) => void;
	memberDating: any;
}) => {
	return (
		<Card style={{ height: '100%', overflowY: 'auto' }}>
			<CardHeader title="הגדרות שלי" />
			<CardContent>
				<table>
					<thead>
						<th className="w-full" />
						<th />
					</thead>
					<tr>
						<td className="td-row-title">בחירת חברה</td>
						<td>
							<Autocomplete
								className="w-full"
								size="small"
								sx={{ minWidth: 170 }}
								options={companies || []}
								getOptionLabel={(o: any) => o?.english_name || ''}
								isOptionEqualToValue={(o: any, v: any) => o?._id === v?._id}
								value={companies?.find((c: any) => c?._id === company) || null}
								onChange={(_e, val: any) => handleChangeMyCompany(val?._id || '')}
								renderInput={(params) => <TextField {...params} placeholder="בחירת חברה" />}
							/>
						</td>
					</tr>
					<tr>
						<td className="td-row-title">בחירת עמוד יועץ</td>
						<td>
							<Autocomplete
								className="w-full"
								size="small"
								sx={{ minWidth: 170 }}
								options={expertStats.data?.experts || []}
								getOptionLabel={(o: any) => o?.name || ''}
								isOptionEqualToValue={(o: any, v: any) => o?._id === v?._id}
								value={expertStats.data?.experts?.find((ex: any) => ex?._id === expertId) || null}
								onChange={(_e, val: any) => handleChangeMyExpert(val?._id || 'null')}
								renderInput={(params) => <TextField {...params} placeholder="בחירת עמוד יועץ" />}
							/>
						</td>
					</tr>
					<tr>
						<td className="td-row-title">
							מיילים עובדי חברות
							<p className="text-xs leading-tight"> (ללא Wix & MyHeritage & Natural)</p>
						</td>
						<td>
							<Button onClick={handleCopyNoWixEmails}>{'העתקה'}</Button>
						</td>
					</tr>
					<tr>
						<td className="td-row-title">מיילים מנוי לידה</td>
						<td>
							<Button disabled={Boolean(activeNewborns.loading)} onClick={handleCopyNewbornEmails}>
								העתקה
							</Button>
						</td>
					</tr>
					<tr>
						<td className="td-row-title">העתקה לפי גיל ילדים</td>
						<td>
							<Button onClick={() => setShowKidsDOBModal(true)}>העתקה</Button>
						</td>
					</tr>

					{/* GH-725 (Terra, 24.9.2026) — "דייטינג מספרים" hidden, dating is no longer in use. Uncomment to bring back. */}
					{/*
					<tr>
						<td className="td-row-title"> דייטינג מספרים</td>
						<td>
							{memberDating.loading ? (
								'טוען...'
							) : (
								`${memberDating.data}`
							)}
						</td>
						
					</tr>
					*/}
				</table>
			</CardContent>
		</Card>
	);
};

export default SettingsCard;
